module.exports = __webpack_public_path__ + "static/8fa93e6416e2f4285fced6f96751eaef.png";